import { jsx as _jsx } from "react/jsx-runtime";
import LocationBlockedContent from '@components/LocationBlockedContent';
import { Modal } from '@components';
const LocationBlockedModal = ({ isOpen, onConfirm, reason }) => (_jsx(Modal, { isOpen: isOpen, size: "xl", preventClose: true, children: _jsx(LocationBlockedContent, { onConfirm: onConfirm, reason: reason }) }));
export default LocationBlockedModal;
